
/**
 * @description
 * 로드맵 상세페이지 > 썸네일 위에 올라가는 좋아요 버튼
 */

import { mapGetters } from 'vuex';

import Icon from '@/components/common/icon/Icon.vue';

export default {
  name: 'CourseFavorite',
  components: { Icon },
  computed: {
    ...mapGetters('course', ['favoriteCount', 'id', 'favoriteCourseObj']),
    ...mapGetters('user/favorite', ['favoriteCourseIds']),
    isFavoriteCourse: ({ favoriteCourseIds, id }) =>
      favoriteCourseIds.includes(id),
  },
  methods: {
    onClickFavorite() {
      this.$emit('on-click-favorite');
    },
  },
};
